import { useEffect } from "react";
import { X, Zap, Brain, Layers, Link } from "lucide-react";

const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScrQtVQ2cn6jnwGwrdkQEFYtrDw1ddOqA6vUphqFj3dxhuyVA/viewform?usp=preview";

const FEATURES = [
  {
    icon: Zap,
    label: "87ms Matching Engine",
    desc: "Sub-second C++ order execution",
  },
  {
    icon: Brain,
    label: "AI Signal Layer",
    desc: "Real-time sentiment feeds",
  },
  {
    icon: Layers,
    label: "Deep Liquidity Core",
    desc: "Cross-market depth aggregation",
  },
  {
    icon: Link,
    label: "On-chain Settlement",
    desc: "Non-custodial, Base Chain native",
  },
];

export default function WaitlistModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center px-4"
      data-testid="waitlist-modal"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/75 backdrop-blur-sm"
        onClick={() => onClose?.()}
      />

      {/* Panel */}
      <div className="glass-panel-active relative z-10 w-full max-w-lg p-8 sm:p-10">
        {/* Close */}
        <button
          onClick={() => onClose?.()}
          className="absolute top-4 right-4 text-slate-500 hover:text-white transition-colors"
          data-testid="waitlist-close"
          aria-label="Close"
        >
          <X size={18} />
        </button>

        {/* Overline */}
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#00F0FF] mb-4">
          // GET EARLY ACCESS
        </p>

        {/* Headline */}
        <h2 className="font-grotesk text-2xl sm:text-3xl font-bold text-white tracking-tight leading-tight mb-4">
          Qovarix is opening its engine —{" "}
          <span className="text-[#00F0FF]">for a select few.</span>
        </h2>

        {/* Description */}
        <p className="font-grotesk text-sm text-slate-400 leading-relaxed mb-8">
          Qovarix is a high-frequency AI prediction market protocol on{" "}
          <span className="text-white font-medium">Base Chain</span>. We are
          inviting early traders to shape the execution layer of the Agentic
          Economy before public launch.
        </p>

        {/* Feature cards */}
        <div className="grid grid-cols-2 gap-3 mb-8">
          {FEATURES.map(({ icon: Icon, label, desc }) => (
            <div
              key={label}
              className="flex items-start gap-3 border border-white/10 bg-black/40 rounded-lg p-3"
            >
              <span className="mt-0.5 shrink-0">
                <Icon size={14} className="text-[#00F0FF]" strokeWidth={1.5} />
              </span>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.1em] text-white leading-tight mb-0.5">
                  {label}
                </p>
                <p className="font-grotesk text-[11px] text-slate-500 leading-snug">
                  {desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button
          onClick={() =>
            window.open(GOOGLE_FORM_URL, "_blank", "noopener,noreferrer")
          }
          className="hero-launch-btn w-full justify-center"
          data-testid="waitlist-submit"
        >
          Apply for Closed Beta
        </button>

        {/* Footer */}
        <p className="font-mono text-[9px] text-slate-600 mt-5 text-center">
          Selected users will be contacted by email · Testnet on Base Chain
        </p>
      </div>
    </div>
  );
}
